import React from "react";
import { UseFormRegister, FieldError } from "react-hook-form";

// Define the interface for the component props
interface TextAreaFieldProps {
  type?: string;
  placeholder?: string;
  name: string;
  register: UseFormRegister<any>; // React Hook Form register function
  error?: FieldError; // Error object from react-hook-form
  setValue: (name: string, value: any, options?: any) => void; // Function to set the value
  className?: string; // Optional class name for styling
  id?: string; // Optional ID for the textarea
  errMsgClassName?: string; // Class for error message styling
  disabled?: boolean; // Whether the textarea is disabled
  readOnly?: boolean; // Whether the textarea is read-only
}

// Define the functional component with the TextAreaFieldProps type
const TextAreaField: React.FC<TextAreaFieldProps> = ({
  type,
  placeholder,
  name,
  register,
  error,
  setValue,
  className = "border border-custom-gray  rounded-[4px] w-full p-2 mt-3", // Default value for className
  id,
  errMsgClassName = "", // Default value for errMsgClassName
  disabled = false, // Default value for disabled
  readOnly = false, // Default value for readOnly
}) => {
  return (
    <div className="form-group">
      <textarea
        id={id}
        placeholder={placeholder}
        onChange={(e) => 
          setValue(name, e.target.value, { shouldValidate: true })
        }
        {...register(name)}
        className={`${error ? "has-error" : ""} ${className ? className : "form-input border-slate-200 dark:border-zink-500"}`}
        disabled={disabled}
        readOnly={readOnly}
      />
      <div>
        {error && (
          <div
            className={
              errMsgClassName
                ? errMsgClassName
                : "text-red-500 font-sm text-[12px]"
            }
          >
            {error.message}
          </div>
        )}
      </div>
    </div>
  );
};

export default TextAreaField;


// type: 'dropdown',
//   label: "text.personalInfo.relationType",
//     name: 'relationType',
//       options: maleRelationOption,
//         error: 'relationType',
//   },
// {
//   type: 'radio',
//   label: "text.personalInfo.genderType",
//   name: 'genderType',
//   options: maleRelationOption,

//   //   options: optionData?.genders?.data,
//   error: 'genderType',
//   selectedValue: selectedValue,
//   onChange: (e) => handleRadioChange1('genderType', e),
//   },
